'use client';

import { FundPageContent } from '../components/FundPageContent';

export default function GrantsPage() {
  return <FundPageContent marketplaceTab="grants" />;
}
